import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';

/**
 * A enum for ads types that are present in drupal as custom blocks types and must be the same in Angular.
 *
 * @export
 * @enum {number}
 */
export enum AdsTypes{
  "double_click_WA100_4.5" = "double_click_WA100_4.5",
  "double_click_WA100_5"="double_click_WA100_5",
  "double_click_WA100_3"="double_click_WA100_3",
  "double_click_WA100_2"="double_click_WA100_2",
  "double_click_WA100_5.5"="double_click_WA100_5.5",
  "double_click_WA100_1"="double_click_WA100_1",
  "double_click_WA100_4"="double_click_WA100_4",
  "double_click_WA122_SANLIDA"="double_click_WA122_SANLIDA",
}

@Component({
  selector: 'app-google-ads',
  templateUrl: './google-ads.component.html',
  styleUrls: ['./google-ads.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GoogleAdsComponent implements OnInit, OnDestroy {

  /**
   * The ads types that matches with drupal block.
   *
   * @type {AdsTypes}
   * @memberof GoogleAdsComponent
   */
  @Input() type: AdsTypes;

  /**
   * The width of component. It's setted automatically based on type property.
   *
   * @memberof GoogleAdsComponent
   */
  width:number;

  /**
   * The height of component. It's setted automatically based on type property.
   *
   * @type {number}
   * @memberof GoogleAdsComponent
   */
  height:number;

  /**
   * The id of div. It's setted automatically based on type property.
   *
   * @type {string}
   * @memberof GoogleAdsComponent
   */
  id:string;

  /**
   * The slot name of ad. It's setted automatically based on type property.
   *
   * @type {string}
   * @memberof GoogleAdsComponent
   */
  slot_name:string;

  /**
   * {@inheritdoc}
   *
   * @memberof GoogleAdsComponent
   */
  ngOnInit(): void {

    const innerWidth = window.innerWidth;

    switch(this.type){
      case AdsTypes['double_click_WA100_4.5']:
        this.slot_name = '/44348975/WA100_4.5';
        this.width = 320;
        this.height = 50;
        this.id = 'div-gpt-ad-'+Math.random().toString();
        break;
      case AdsTypes.double_click_WA100_5:
        this.slot_name = '/44348975/WA_100_5';
        this.width = 728;
        this.height = 90;
        this.id = 'div-gpt-ad-'+Math.random().toString();
        break;
      case AdsTypes.double_click_WA100_1:
        this.slot_name = '/44348975/WA100_1';
        this.width = 728;
        this.height = 90;
        this.id = 'div-gpt-ad-'+Math.random().toString();
        break;
      case AdsTypes.double_click_WA100_2:
        this.slot_name = '/44348975/WA100_2';
        this.width = 336;
        this.height = 280;
        this.id = 'div-gpt-ad-'+Math.random().toString();
        break;
      case AdsTypes.double_click_WA100_3:
        this.slot_name = '/44348975/WA100_3';
        this.width = 336;
        this.height = 280;
        this.id = 'div-gpt-ad-'+Math.random().toString();
        break;
      case AdsTypes.double_click_WA100_4:
        this.slot_name = '/44348975/WA100_3';
        this.width = 336;
        this.height = 280;
        this.id = 'div-gpt-ad-'+Math.random().toString();
        break;
      case AdsTypes['double_click_WA100_5.5']:
        this.slot_name = '/44348975/WA100_4';
        this.width = 336;
        this.height = 280;
        this.id = 'div-gpt-ad-'+Math.random().toString();
        break;
      case AdsTypes['double_click_WA122_SANLIDA']:
        this.slot_name = '/44348975/WA122_SANLIDA';


        if (innerWidth < 1000) {
          this.width = 320;
          this.height = 50;
        } else {
          this.width = 980;
          this.height = 120;
        }

        this.id = 'div-gpt-ad-'+Math.random().toString();
        break;
    }
  }

  /**
   * The init script of ads block.
   *
   * @readonly
   * @memberof GoogleAdsComponent
   */
  get configureInit(){
    return `if(googletag){
      googletag.cmd.push(function() {
      googletag.defineSlot('${this.slot_name}', [${this.width}, ${this.height}], '${this.id}').addService(googletag.pubads());
      googletag.pubads().enableSingleRequest();
      googletag.enableServices();
    }
    )};`;
  }

  /**
   * The div block configuration.
   *
   * @readonly
   * @memberof GoogleAdsComponent
   */
  get configureDivBlock(){
    return `if(googletag){
      googletag.cmd.push(function() { googletag.display('${this.id}'); })
    };`;
  }

  /**
   * {@inheritdoc}
   *
   * @memberof GoogleAdsComponent
   */
  ngOnDestroy(): void {
    document.getElementById(this.id).remove()
  }


}
